//NOTE: Subscriptionts plan id
export const FREE = 1;
export const BASIC = 2;
export const GROWTH = 3;
export const PRO = 4;
export const ENTERPRISE = 5;
export const BASIC_ONDEMAND = 6;
export const GROWTH_ONDEMAND = 7;
export const PRO_ONDEMAND = 8;
export const ENTERPRISE_ONDEMAND = 9;
export const PROMOTION = 10;
export const STARTER = 11;
export const PROFESSIONAL = 12;
export const PREMIUM = 13;
export const ENTERPRISE_V2 = 14;

//NOTE: Packages key name
export const FOLIOS = 'folios';
export const ADONS = 'adons';
export const DOWNLOADS = 'downloads';
export const SMS = 'reminder-sms';
export const USERS = 'users';
export const CUSTOMERS = 'customers';
export const EMAILS = 'reminder-mail';
export const WHATSAPP = 'whatsapp';

//NOTE: Credits key name
export const CREDITS = 'credits';

//NOTE: Adons key name
export const STRIPE = 'stripe';
export const STP = 'stp';
export const OXXO = 'oxxo';
export const CONEKTA = 'conekta';
export const FISERV = 'fiserv';
export const KUSHKI = 'kushki';
export const CONTPAQI = 'contpaqi';
export const TAX_STAMPS = 'tax-stamps';
export const EXPORT_DATA = 'export-data';
export const ACCOUNT_STATEMENT = 'account-statement';
export const ADD_USER = 'add-user';
export const BRANDING = 'branding';
export const ADD_CUSTOMERS = 'add-customers';
export const ADD_CREDITS = 'add-credits';
export const API = 'api';
export const WHATSAPP_ACTIVE = 'whatsapp-active';

//NOTE: Packages and features status
export const UNLIMITED_STATUS = 'unlimited';
export const NO_AVAILABLE_FEATURE = 'na';

//NOTE: Credits options
export const CREDITS_OPTION_ONE = {
  amount: 100,
  price: 199,
  id: 'code100Credits'
};
export const CREDITS_OPTION_TWO = {
  amount: 500,
  price: 749,
  discount: '25%',
  id: 'code500Credits'
};
export const CREDITS_OPTION_THREE = {
  amount: 1000,
  price: 999,
  discount: '50%',
  id: 'code1000Credits'
};
export const CREDITS_OPTION_FOUR = {
  amount: 2000,
  price: 1799,
  discount: '60%',
  id: 'code2000Credits'
};

export const CUSTOMER_PRICE = {
  amount: 100,
  price: 10,
  id: 'code100Customers'
};

//NOTE: API error if payment method is missing paying credits
export const ERROR_PAYMENT_METHOD = {
  code: 127,
  message: 'Payment method is required'
};



// WEBPACK FOOTER //
// ./src/constants/subscriptions.js